import * as React from 'react';

interface ITitleProps {
    children: any;
    type?: string;
    El?: string;
}

const Title = (props: any) => {
    const { type, children } = props;

    return (
        <div className={'title' + (type ? ' title--' + props.type : '')}>
            {children}
        </div>
    );
};

export default Title;



// WEBPACK FOOTER //
// ./src/modules/Title/Title.tsx